/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAudienceOptionsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListAudienceOptionsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAudienceOptionsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAudienceOptionsSecurity$outboundSchema: z.ZodMiniType<
  ListAudienceOptionsSecurity$Outbound,
  ListAudienceOptionsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAudienceOptionsSecurityToJSON(
  listAudienceOptionsSecurity: ListAudienceOptionsSecurity,
): string {
  return JSON.stringify(
    ListAudienceOptionsSecurity$outboundSchema.parse(
      listAudienceOptionsSecurity,
    ),
  );
}

/** @internal */
export type ListAudienceOptionsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAudienceOptionsRequest$outboundSchema: z.ZodMiniType<
  ListAudienceOptionsRequest$Outbound,
  ListAudienceOptionsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listAudienceOptionsRequestToJSON(
  listAudienceOptionsRequest: ListAudienceOptionsRequest,
): string {
  return JSON.stringify(
    ListAudienceOptionsRequest$outboundSchema.parse(listAudienceOptionsRequest),
  );
}
